import ko from '@tko/build.knockout';
import MenuIcons from '../../../../app/helpers/menu-icons';
import PermissionService from '../../../../services/permission.service';
import '../../components/capture/capture';
import LoginService from "../../../../services/login.service";
import DataProvider from "../../../../app/data-framework/data-provider";

function AssuranceAppShellView(params) {
    var self = this;
    self.initialize(params);
}

AssuranceAppShellView.prototype = {
    initialize: function (params) {
        let self = this;
        self.dataProvider = DataProvider.getInstance();
        self.permissionService = new PermissionService(LoginService.userObject);
        self.route = params.route;

        self.app = self.dataProvider.getModuleDictionary().assurance;
        self.routeParams = ko.pureComputed(function () { return ko.unwrap(self.route); });
        self.view = ko.pureComputed(function () { return ko.unwrap(self.route).view; });

        self.showWatermark = sessionStorage.getItem('feature.events') ? true : false;

        var appMenuItems = self.dataProvider.getListOfApps();

        var subModules = [
            { id: 'assuranceDashboards', name: 'Dashboards', icon: MenuIcons.getDashboard(), url: '#monitoring/dashboard', badge: undefined, views: [] },
        ];

        if (self.permissionService.hasPermission(self.permissionService.ViewDatasetsPermission)) {
            subModules.push(
                { id: 'assuranceDatasets', name: 'Datasets', icon: MenuIcons.getDatasets(), url: undefined, badge: undefined, views: [
                    { id: 'infrastructure', url: '#monitoring/infrastructure', name: 'Infrastructure', badge: undefined},
                    { id: 'trunks', url: '#monitoring/trunks', name: 'Trunks', badge: undefined },
                    { id: 'endpoints', url: '#monitoring/endpoints', name: 'Endpoints', badge: undefined},
                    { id: 'meetings', url: '#monitoring/meetings', name: 'Meetings', badge: undefined},
                    { id: 'calls', url: '#monitoring/calls', name: 'Calls', badge: undefined}
                ]}
            );
        }

        if (self.permissionService.hasPermission(self.permissionService.AlertsManagerPermission)) {
            const monitoringViews = [
                { id: 'moi', url: '#monitoring/moi', name: 'Monitors', badge: undefined },
            ];
            if (DataProvider.getInstance().isInternalUser() || LoginService.userObject.featureFlags.EventsOptIn) {
                monitoringViews.push(
                  { id: 'events', url: '#monitoring/events', name: 'Events', badge: 'new'},
                );
            }
            if (!LoginService.userObject.legacyAlertsHide) {
                monitoringViews.push(
                    { id: 'alerts', name: 'Legacy Monitors', url: '#monitoring/alerts', badge: undefined }
                );
            }
            subModules.push(
                { id: 'monitors', name: 'Monitors', icon: MenuIcons.getMoi(), url: undefined, badge: undefined, views: monitoringViews },
            );
        }

        //add settings to the end
        if (self.permissionService.hasPermission(self.permissionService.SettingsViewPermission)) {
            subModules.push({id: 'assuranceSettings', name: 'Settings', icon: MenuIcons.getSettings(), url: '#monitoring/settings', badge: undefined, views: []});
        }

        self.appsMenu = ko.observableArray(appMenuItems);
        self.sideMenu = ko.observableArray(subModules);

        self.component = {
            name: self.view,
            params: {
                //  'dataProvider' is exclusively used in 'alerts' & 'settings' tabs
                dataProvider: self.dataProvider,

                route: self.route,
                routeParams: self.routeParams,
                menus: self.sideMenu
            }
        };
    }
};

export default AssuranceAppShellView;
